import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { Container, Heading } from "@radix-ui/themes";
import { FC, JSX } from "react";

interface AdminAuthProps {
  children: React.ReactNode;
}

const AdminAuth: FC<AdminAuthProps> = ({ children }): JSX.Element => {
  const user = useCurrentUserProfile((s) => s.user);
  const isAdmin = user.isAdmin;

  if (!isAdmin) {
    return (
      <Container>
        <Heading as="h1" size="7">
          You are not authorized to view this page.
        </Heading>
      </Container>
    );
  }

  return <>{children}</>;
};

export default AdminAuth;
